module.exports = __webpack_public_path__ + "img/offers.835368ed.svg";